"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deprecatedProp = deprecatedProp;
exports.useMemoizedId = exports.mapBsStyleToColor = void 0;

var _react = require("react");

var _v = _interopRequireDefault(require("uuid/v4"));

var colors = _interopRequireWildcard(require("./colors"));

function createUniqueId(label) {
  var uniqueId = "".concat(label, "-").concat((0, _v["default"])());
  return uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
} // eslint-disable-next-line import/prefer-default-export


var mapBsStyleToColor = function mapBsStyleToColor(bsStyle) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$shade = _ref.shade,
      shade = _ref$shade === void 0 ? 'base' : _ref$shade,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? colors.coal : _ref$fallback;

  var result = colors[bsStyle];

  if (result && result[shade]) {
    result = result[shade];
  } else {
    result = fallback;
  }

  return result;
};
/**
 * @param {string} myObj.id If you already have a unique id that you want memoized.
 * @param {string} myObj.label Generate a unique id with the following label.
 */


exports.mapBsStyleToColor = mapBsStyleToColor;

var useMemoizedId = function useMemoizedId(_ref2) {
  var label = _ref2.label,
      id = _ref2.id;
  return (0, _react.useMemo)(function () {
    return id || createUniqueId(label);
  }, [label, id]);
};

exports.useMemoizedId = useMemoizedId;

function deprecatedProp(validator) {
  var suggestion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function deprecated(props, propName) {
    if (props[propName] != null) {
      console.warn("".concat(propName, " is deprecated. ").concat(suggestion));
    }

    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    return validator.apply(void 0, [props, propName].concat(rest));
  };
}